/**
 * Created by henian.xu on 2018/9/11.
 * buyer 基类 继承用
 */
import HttpBase from '@/api/base/HttpBase';

class Feedback extends HttpBase {
  constructor() {
    super();
    this.baseUrl += '/rpc/feedback';
  }
}

export default new Feedback();
export { Feedback };
